<template>
  <div class="h-screen">
    <chat class="my-0 h-full" :job="job" :conversation="conversation" :messages="messages"></chat>
  </div>
</template>

<script>
import Chat from '../../Shared/Chat';

export default {
  props: {
    job: Object,
    messages: Object,
    conversation: Object,
  },
  components: {
    Chat,
  },
  mounted() {
    window.Echo.channel('App.Models.User.' + this.$page.props.auth.user.id)
        .listen('MessageCreatedEvent', (data) => {
          if (
              data.device_client_id === sessionStorage.getItem('deviceClientId')
              && data.author_id == this.$page.props.auth.user.id
              && data.author_type === 'App\\Models\\User'
          ) {
            return;
          }

          this.$inertia.reload({
            preserveState: true,
            preserveScroll: true
          })
        });
  }
};
</script>
